import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import React, { ReactElement } from 'react';
import { IButtonProps } from '../Button';

export interface IEmptyStateIconProps {
  /**
   * Font Awesome icon
   */
  icon: IconProp;
  /**
   *  Icon's size. Use Font Awesome measurements to set it.
   */
  size?: SizeProp;
  /**
   *  Icon's color.
   */
  color?: string;
  /**
   *  Icon's wrapper background.
   */
  background?: string;
}

export interface IEmptyStateCardProps {
  /**
   *  Array of Font Awesome icons. Can have two or three items.
   */
  icons:
    | [IEmptyStateIconProps, IEmptyStateIconProps, IEmptyStateIconProps]
    | [IEmptyStateIconProps, IEmptyStateIconProps];
  /**
   *  Primary text.
   */
  primaryText?: string;
  /**
   *  Secondary text.
   */
  secondaryText?: React.ReactNode;
  /**
   *  Array of buttons.
   */
  buttons?: ReactElement<IButtonProps>[];
  /**
   * Helper attribute for QA. Adds "qa-id" attribute to component's container
   */
  'qa-id'?: string;
}
